<template>
  <div class="rank-report-targeting">
    <label class="form__input">
      <span class="form__label">GEO</span>
      <base-select
        :headerStyle="{ 'border-width': '2px' }"
        alignLeft
        shiftLabelRight
        isSmartInput
        :smartInputStyle="{ 'padding-left': '20px' }"
        :class="{'form__field_error': $parent.errorFields.geo}"
        :placeholder="placeHolders.geo"
        :options="geo"
        :selectStyle="{ height: '60px !important' }"
        v-model="$parent.urlDataModel.rank_report_targeting.geo"
        :max-height-list="450"
      />
      <span class="form__error-message" v-if="$parent.errorFields.geo">{{ $parent.errorFields.geo }}</span>
    </label>
    <label class="form__input">
      <span class="form__label">Device</span>
      <base-select
        :headerStyle="{ 'border-width': '2px' }"
        alignLeft
        shiftLabelRight
        :class="{'form__field_error': $parent.errorFields.device}"
        :placeholder="placeHolders.device"
        :options="device"
        :selectStyle="{ height: '60px !important' }"
        v-model="$parent.urlDataModel.rank_report_targeting.device"
        :max-height-list="450"
      />
      <span class="form__error-message" v-if="$parent.errorFields.device">{{ $parent.errorFields.device }}</span>
    </label>
    <label class="form__input">
      <span class="form__label">Locale</span>
      <base-select
        :headerStyle="{ 'border-width': '2px' }"
        alignLeft
        shiftLabelRight
        isSmartInput
        :smartInputStyle="{ 'padding-left': '20px' }"
        :class="{'form__field_error': $parent.errorFields.locale}"
        :placeholder="placeHolders.locale"
        :options="locale"
        :selectStyle="{ height: '60px !important' }"
        v-model="$parent.urlDataModel.rank_report_targeting.locale"
        :max-height-list="450"
      />
      <span class="form__error-message" v-if="$parent.errorFields.locale">{{ $parent.errorFields.locale }}</span>
    </label>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'UrlRankReportTargeting',
  computed: {
    ...mapState('urlCensus', {
      geo: 'geo',
      device: 'device',
      locale: 'locale',
      placeHolders (state) {
        return {
          geo: state.clientDefaultRRT.geo ? (state.geo.find(i => i.value === state.clientDefaultRRT.geo) || {}).label || 'Select GEO' : 'Select GEO',
          device: state.clientDefaultRRT.device ? (state.device.find(i => i.value === state.clientDefaultRRT.device) || {}).label || 'Select Device' : 'Select Device',
          locale: state.clientDefaultRRT.locale ? (state.locale.find(i => i.value === state.clientDefaultRRT.locale) || {}).label || 'Select Locale' : 'Select Locale'
        }
      }
    })
  }
}
</script>

<style lang="scss" scoped>
  .rank-report-targeting {}
</style>
